import bocapioCakeService from "@/services/cakephp"
import nodeService from "@/services/nodejs"
import swal from "sweetalert2"

const getAllAgents = async (state, params) => {
  try {
    var agent = undefined
    if(params == undefined){
      const place = state.rootGetters["auth/getPlace"]
      const user = state.rootGetters["auth/user"]

      agent = user.uuid || place.janooUserUuid
    }
    else{
      agent = params
    }

    await bocapioCakeService.getAgents(agent)
        .then(response => {
          state.commit('SET_AGENTS_LIST', response.list)
        })
  }
  catch (error) {
  }
}

const getAgentByUUID = async (state, uuid) => {
  try {
    const agent = await bocapioCakeService.getAgentByUUID(uuid)
    return agent
  }
  catch (error) {
  }
}

const checkExpressBooking = (state, payload) => {
  nodeService.postCheckinExpressBooking(payload)
    .then(res=>{
    })
    .catch((error) => {})
}

const addBookingAgent = async (state, payload) => {
  await nodeService.postAddBookingAgent(payload)
    .then(res=>{
    })
    .catch((error) => {})
}

const removeBookingAgent = async (state, payload) => {
  await nodeService.postRemoveBookingAgent(payload)
    .then(res=>{
    })
    .catch((error) => {})
}

const cancelExpressBooking = async (state, payload) => {
  await nodeService.postCancelExpressBooking(payload)
    .then(res=>{
    })
    .catch((error) => {})
}

const updateExpressBookingDate = (state, payload) => {
  nodeService.postUpdateExpressBookingDate(payload)
    .then(res=>{
    })
    .catch((error) => {})
}

const updateExpressBookingTickets = async (state, payload) => {
  var form = {
    hash: payload.hash,
    message: payload.message,
    pixRefund: payload.pixRefund,
    pix_code: payload.pix,
    indexes: {}
  }

  form.tickets = payload.tickets.filter(t => t.quantity > 0)
  form.tickets.map(function(value, index){ form.indexes[value.id] = value.quantity })

  delete form.tickets

  if(payload.pixRefund){ form.pix = payload.pix }

  await nodeService.postUpdateExpressBookingTickets(form)
    .then(res=>{
        // this.$notify({ message: 'Sucesso ao atualizar reserva', duration: 6000, type: "success" })
        swal.fire({
            text: "Sucesso ao atualizar reserva!",
            icon: 'success',
            showCancelButton: false,
            confirmButtonText: 'Fechar',
            confirmButtonColor: '#A7AA37',
            type: 'success'
        })
    })
    .catch((error) => {
      if(error.status != 200){
        // this.$notify({ message: 'Erro ao atualizar reserva', duration: 6000, type: "error" })
        swal.fire({
            text: "Erro ao atualizar reserva!",
            icon: 'error',
            showCancelButton: false,
            confirmButtonText: 'Fechar',
            confirmButtonColor: '#D93051',
            type: 'error'
        })
      }
    })
}

// /**
//  * Carrega lista de POIs (atrativos) do {{ USER_UUID }}
//  * @param {*} state
//  * @param {*} USER_UUID
//  */
// const fetchProductsList = async (state, USER_UUID) => {
//   state.commit('RESET_PRODUCT_LIST')

//   await nodeService.getPoisByVendor(USER_UUID)
//     .then(response => {
//       state.commit('SET_PRODUCT_LIST', response.data)
//     })
// }

export default {
  getAllAgents,
  getAgentByUUID,
  addBookingAgent,
  removeBookingAgent,
  checkExpressBooking,
  cancelExpressBooking,
  updateExpressBookingDate,
  updateExpressBookingTickets,
  // fetchProductsList,
}
